var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.64 29.92L34.36 58.2L17.4 41.24L23.04 35.6L34.36 46.92L57 24.28L62.64 29.92ZM8 39.8C8 30.48 12.08 22.12 18.48 16.28L28 25.8V1.8H4L12.8 10.6C4.96 17.88 0 28.24 0 39.8C0 60.56 15.8 77.6 36 79.6V71.52C20.24 69.56 8 56.08 8 39.8ZM80 39.8C80 19.04 64.2 2 44 0V8.08C59.76 10.04 72 23.52 72 39.8C72 49.12 67.92 57.48 61.52 63.32L52 53.8V77.8H76L67.2 69C75.04 61.72 80 51.36 80 39.8Z",
    fill: "#2E397E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.b366c058b36fd7265676d88d8e1b5d1c.svg";
export { ForwardRef as ReactComponent };